import { render, staticRenderFns } from "./ProtectionFromWhom.vue?vue&type=template&id=3d9b0a79"
import script from "./ProtectionFromWhom.vue?vue&type=script&lang=ts"
export * from "./ProtectionFromWhom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports